import React from "react";
import "./PromoNavara.scss";
import promoimg from "../../Media/Hardsell_Navara.webp";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faMedal} from "@fortawesome/free-solid-svg-icons";

const Cherrywa = () => {
  const whatsappLink =
    "https://api.whatsapp.com/send/?phone=6281311110717&text=Halo%20Uki,%20Saya%20bisa%20minta%20detail%20Katalog,%20Simulasi,%20dan%20Promo%20terbaru%20Produk%20Kota%20Harapan%20Indah%20(Promo%20Navara)%20https://kota-harapan-indah.id//&type=phone_number&app_absent=0";
  window.location.href = whatsappLink;
};

const promo = () => {
  return (
    <div id="promo" className="promolagoon">
      <div className="background">
        <div className="container-promo">
          <div className="promo-gambar">
            <img src={promoimg} alt={promoimg} />
          </div>
          <div className="containercontent">
            <div className="judul">
              <h1>New Launching Cluster Navara</h1>
            </div>
            <div className="pointpenawaran">
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>&nbsp;&nbsp;Subsidi DP</span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>&nbsp;&nbsp;Free Biaya KPR</span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>
                  &nbsp;&nbsp;Free Biaya BPHTB
                </span>
              </div>

              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>&nbsp;&nbsp;Free CCTV</span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>
                  &nbsp;&nbsp;Free Smart Lamp
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>
                  &nbsp;&nbsp;Free Smart Door Lock
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>
                  &nbsp;&nbsp;Free Free Voucher Belanja
                </span>
              </div>
              <div className="penawaranpoin">
                <FontAwesomeIcon icon={faMedal} />
                <span style={{color: "white"}}>
                  &nbsp;&nbsp;Cicilan Start 8 Juta/Bulan
                </span>
              </div>
            </div>
            <div className="disclaimer">*Disclaimer</div>
            <button className="buttonpenawaran" onClick={Cherrywa}>
              Learn More
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default promo;
